import { channelFiltterOptions } from 'json/goods-order-options'
// 定金结算筛选条件
export let filterLabels = [
  {
    label: '订单时间',
    type: 'time-slot',
    value: 'orderDate',
    clearable: true,
    startName: 'startDate', // 返回数据时，开始时间的字段名
    endName: 'endDate' // 返回数据时，结束时间的字段名
  },
  {
    label: '分子公司',
    type: 'select',
    value: 'organizationId',
    clearable: true,
    options: []
  },
  {
    label: '地区',
    type: 'address-select',
    value: 'addressCodes',
    clearable: true,
    addressShowElement: {
      province: true,
      city: true,
      district: true
    }
  },
  {
    label: '下单方式',
    type: 'select',
    value: 'depositAuditOrderingType',
    clearable: true,
    options: [
      {
        label: '运营活动',
        value: 'OPERATING_ACTIVITY'
      },
      {
        label: '预约报名',
        value: 'APPOINTMENT'
      }
    ]
  },
  {
    label: '奖励状态',
    type: 'select',
    value: 'rewardStatus',
    clearable: true,
    options: [
      {
        label: '已审核',
        value: 'APPROVED'
      },
      {
        label: '未审核',
        value: 'UNAPPROVED'
      },
      {
        label: '无奖励',
        value: 'NO_REWARD'
      }
    ]
  },
  {
    label: '支付方式',
    type: 'select',
    value: 'payChannel',
    clearable: true,
    options: channelFiltterOptions
  }
]
